import { CoreToolboxComponentIds } from "../CoreToolboxComponentIds";
/**
 * KvadratVPCComponent is a component for holding the VPC code of a Kvadrat room.
 * The purpose is to hold the Kvadrat VPC code when the scene is saved, so that it can be restored when
 * the solution is read.
 *
 * For Core to be able to deserialize this component, you need to register the {@link KvadratVPCComponentSerializer}.
 */
var KvadratVPCComponent = /** @class */ (function () {
    function KvadratVPCComponent(vpc) {
        this.typeId = KvadratVPCComponent.id;
        this.doStoreInSnapshot = false;
        this.serializable = true;
        this.vpc = vpc;
    }
    KvadratVPCComponent.prototype.serializationKey = function () {
        return KvadratVPCComponent.KEY;
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    KvadratVPCComponent.prototype.toJson = function (parse) {
        return parse(JSON.stringify(this.vpc));
    };
    KvadratVPCComponent.prototype.eq = function (other) {
        return other.vpc === this.vpc;
    };
    KvadratVPCComponent.id = CoreToolboxComponentIds.KvadratVPCComponentId;
    KvadratVPCComponent.KEY = "kvadrat_vpc_code";
    return KvadratVPCComponent;
}());
export { KvadratVPCComponent };
/**
 * THe KvadratVPCComponentSerializer is needed if you want to deserialize the {@link KvadratVPCComponent}.
 * Register it with the `Core.services.componentSerializerRegistry`.
 */
var KvadratVPCComponentSerializer = /** @class */ (function () {
    function KvadratVPCComponentSerializer() {
        this.thisClassIsGuaranteedToNotModifyOrQueryCoreState = true;
    }
    KvadratVPCComponentSerializer.prototype.canHandle = function (serializationKey) {
        return serializationKey == KvadratVPCComponent.KEY;
    };
    KvadratVPCComponentSerializer.prototype.deserialize = function (serializationKey, json) {
        if (serializationKey == KvadratVPCComponent.KEY) {
            var vpc = JSON.parse(json.toString());
            return new KvadratVPCComponent(vpc);
        }
        return null;
    };
    return KvadratVPCComponentSerializer;
}());
export { KvadratVPCComponentSerializer };
//# sourceMappingURL=KvadratVPCComponent.js.map